import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../config';


const Login = ({ onLoginSuccess }: { onLoginSuccess: (token: string) => void }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        // FastAPI OAuth2PasswordRequestForm wymaga danych w formacie form-data
        const formData = new FormData();
        formData.append('username', email);
        formData.append('password', password);

        try {
            // 2. Używamy API_URL zamiast zahardkodowanego adresu
            const res = await axios.post(`${API_URL}/auth/login`, formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            localStorage.setItem('token', res.data.access_token);
            onLoginSuccess(res.data.access_token);
        } catch (err: any) {
            // Logujemy błąd do konsoli, żebyś widział jeśli to np. błąd CORS
            console.error("Błąd logowania:", err.response?.data || err.message);
            setError('Błędny email lub hasło');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f7f6f2',
            fontFamily: "'Inter', system-ui, sans-serif",
        }}>
            <div style={{
                width: '100%',
                maxWidth: '360px',
                padding: '0 16px',
            }}>
                {/* Logo + nazwa */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginBottom: '32px',
                    gap: '12px',
                }}>
                    <img
                        src="/favicon.png"
                        alt="Wodociągi Gruta"
                        width={52}
                        height={52}
                        style={{ borderRadius: '12px' }}
                    />
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            fontSize: '20px',
                            fontWeight: 600,
                            color: '#1a1916',
                            letterSpacing: '-0.3px',
                        }}>Wodociągi Gruta</div>
                        <div style={{
                            fontSize: '13px',
                            color: '#7a7974',
                            marginTop: '2px',
                        }}>Zarządzanie siecią wodociągową dla jednostek terytorialnych</div>
                    </div>
                </div>

                {/* Karta formularza */}
                <div style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    border: '1px solid rgba(0,0,0,0.08)',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    padding: '28px 24px',
                }}>
                    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <label style={{ fontSize: '13px', fontWeight: 500, color: '#3a3835' }}>
                                Email
                            </label>
                            <input
                                type="email"
                                placeholder="nazwa@gmina.pl"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                                style={{
                                    padding: '9px 12px',
                                    fontSize: '14px',
                                    border: '1px solid #d4d1ca',
                                    borderRadius: '7px',
                                    outline: 'none',
                                    color: '#1a1916',
                                    backgroundColor: '#fafaf8',
                                    transition: 'border-color 150ms',
                                }}
                                onFocus={e => e.target.style.borderColor = '#01696f'}
                                onBlur={e => e.target.style.borderColor = '#d4d1ca'}
                            />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <label style={{ fontSize: '13px', fontWeight: 500, color: '#3a3835' }}>
                                Hasło
                            </label>
                            <input
                                type="password"
                                placeholder="••••••••"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                required
                                style={{
                                    padding: '9px 12px',
                                    fontSize: '14px',
                                    border: '1px solid #d4d1ca',
                                    borderRadius: '7px',
                                    outline: 'none',
                                    color: '#1a1916',
                                    backgroundColor: '#fafaf8',
                                    transition: 'border-color 150ms',
                                }}
                                onFocus={e => e.target.style.borderColor = '#01696f'}
                                onBlur={e => e.target.style.borderColor = '#d4d1ca'}
                            />
                        </div>

                        {error && (
                            <div style={{
                                fontSize: '13px',
                                color: '#a12c7b',
                                backgroundColor: '#fdf4f9',
                                border: '1px solid #e0ced7',
                                borderRadius: '6px',
                                padding: '8px 10px',
                            }}>
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                marginTop: '4px',
                                padding: '10px',
                                fontSize: '14px',
                                fontWeight: 500,
                                backgroundColor: loading ? '#cedcd8' : '#01696f',
                                color: loading ? '#7a7974' : '#ffffff',
                                border: 'none',
                                borderRadius: '7px',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                transition: 'background-color 150ms',
                                letterSpacing: '0.1px',
                            }}
                            onMouseEnter={e => { if (!loading) (e.target as HTMLButtonElement).style.backgroundColor = '#0c4e54'; }}
                            onMouseLeave={e => { if (!loading) (e.target as HTMLButtonElement).style.backgroundColor = '#01696f'; }}
                        >
                            {loading ? 'Logowanie…' : 'Zaloguj się'}
                        </button>
                    </form>
                </div>

                <p style={{
                    textAlign: 'center',
                    fontSize: '12px',
                    color: '#bab9b4',
                    marginTop: '20px',
                }}>
                    Wodociągi Gruta by budziun
                </p>
            </div>
        </div>
    );
};

export default Login;